import { render, staticRenderFns } from "./icon-rounded-object.vue?vue&type=template&id=480fd82e&scoped=true&"
import script from "./icon-rounded-object.vue?vue&type=script&lang=js&"
export * from "./icon-rounded-object.vue?vue&type=script&lang=js&"
import style0 from "./icon-rounded-object.vue?vue&type=style&index=0&id=480fd82e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fd82e",
  null
  
)

export default component.exports